import { modifiers } from "ui-tools"
import s from "./PieChart.module.scss"

type PieChartProps = {
  progressPercentage?: number
  size?: "small" | "medium" | "large" | "extraLarge"
  title?: string
}
export const PieChart = ({
  progressPercentage = 0,
  size = "medium",
  title,
}: PieChartProps) => {
  // We add +1 to the second color's percentage to smooth out the edge
  // as there might be anti-aliasing artifacts for odd percentages
  const gradientStyle = `conic-gradient(
    white ${progressPercentage}%,
    transparent ${progressPercentage + 1}%)
  `

  return (
    <div
      className={modifiers(s, "container", size)}
      title={title ?? `${progressPercentage}%`}
    >
      <div
        className={s.container__pie}
        style={{
          backgroundImage: gradientStyle,
        }}
      />
    </div>
  )
}

PieChart.Skeleton = ({ size }: PieChartProps) => (
  <div className={modifiers(s, "container", "skeleton", size)} />
)
